export const color = {
    // styles-color
    white: {
        color: 'rgb(255, 255, 255)'
    },
    blue: {
        color: 'rgb(0, 51, 141)'
    },
    medium_blue: {
        color: 'rgb(0, 94, 184)'
    },
    light_blue: {
        color: 'rgb(0, 145, 218)'
    },
    violet: {
        color: 'rgb(72, 54, 152)'
    },
    purple: {
        color: 'rgb(71, 10, 104)'
    },
    light_purple: {
        color: 'rgb(109, 32, 119)'
    },
    green_blue: {
        color: 'rgb(0, 163, 161)'
    },
    dark_green: {
        color: 'rgb(0, 154, 68)'
    },
    light_green: {
        color: 'rgb(67, 176, 42)'
    },
    yellow: {
        color: 'rgb(234, 170, 0)'
    },
    orange: {
        color: 'rgb(246, 141, 46)'
    },
    red: {
        color: 'rgb(188, 32, 75)'
    },
    pink: {
        color: 'rgb(199, 0, 126)'
    },
    dark_brown: {
        color: 'rgb(117, 63, 25)'
    },
    light_brown: {
        color: 'rgb(155, 100, 46)'
    },
    olive: {
        color: 'rgb(157, 147, 117)'
    },
    belge: {
        color: 'rgb(227, 188, 159)'
    },
    light_pink: {
        color: 'rgb(227, 104, 119)'
    },
    bright_yellow: {
        color: 'rgb(255, 227, 10)'
    },
    grey: {
        color: 'rgb(157, 147, 117)'
    },
    green: {
        color: 'rgb(67, 176, 42)'
    },
    amber: {
        color: 'rgb(246, 141, 46)'
    },
    black: {
        color: 'rgb(0, 0, 0)'
    }
}


// WEBPACK FOOTER //
// ./src/components/CSS/color.js